module.exports = __webpack_public_path__ + "static/bg-me-309ca2a47829f3e5cef52b1f36354851.jpg";